"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NavIcon = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tfont-size: 2rem;\n\tplace-items: center;\n\tcolor: ", ";\n\tcursor: pointer;\n\t/* display: none; */\n\tdisplay: grid;\n\t", "\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tmargin: 0 2rem;\n\t}");
});
exports.NavIcon = NavIcon;